import { Injectable, inject } from '@angular/core';
import { TslApiService } from 'projects/aztalena-core/src/public-api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  private api = inject(TslApiService);

  report(itemType: string, itemId: string, reason: string): Observable<void> {
    return this.api.post('report', { itemType, itemId, reason });
  }
}
